import { useUiStore } from "@/store";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"

const helper = {
  async updateStatus({item, updateApi, fetchData, payload = {}}) {
    const uiStore = useUiStore();
    uiStore.startLoading();
    try {
      await updateApi(item.id, { is_active: !item.status, ...payload });
      await fetchData();
      uiStore.showNotification("Status Updated Successfully", "success");
    } catch (error) {
      uiStore.showNotification("Failed to update status", "error");
    } finally {
      uiStore.stopLoading();
    }
  },

  exportCsv( data, filename = "data.csv", fields = []) {
      const uiStore = useUiStore();
      if (!data?.length) {
        uiStore.showNotification("No data to export", "warning");
        return;
      }
      const headers = fields.join(",") + "\n";
      const rows = data
        .map((item) => fields.map((field) => `"${item[field] ?? ""}"`).join(","))
        .join("\n");
      const csvContent = headers + rows;
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      uiStore.showNotification("Data Exported Successfully", "success");
  },
  
  exportPdf(data, filename = "data.pdf", fields = []) {
      const uiStore = useUiStore();
      if (!data?.length) {
        uiStore.showNotification("No data to export", "warning");
        return;
      }
      try {
        const doc = new jsPDF();
        const headers = [fields];

        const rows = data.map((item) => fields.map((field) => item[field] ?? ""));
        autoTable(doc, {
          head: headers,
          body: rows,
          theme: "grid",
          styles: {
            fontSize: 9,
          },
        });

        const blob = doc.output("blob");
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.style.display = "none";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 100);

        uiStore.showNotification("Data Exported Successfully","success");
      } catch (error) {
        console.error("PDF export error:", error);
        uiStore.showNotification("Failed to export PDF","error");
      }
},
};
export default helper;